import {call, put, takeLatest} from "redux-saga/effects";
import * as types from "../../actions/actionTypes";
import {DashboardAction} from "../../actions";
import * as DashboardApi from "../../api/dashboard/pettyCashierDashboard";
import {SetMessage} from "../../assets/errorMessages";

export function* watcherPettyCashierDashboard() {
  yield takeLatest(types.PETTY_CASHIER_DASHBOARD_GET_2_NUMBERS_REQUEST, workerPettyCashier2Number);
  yield takeLatest(types.PETTY_CASHIER_DASHBOARD_GET_CASH_REMAIN_REQUEST, workerPettyCashierCashRemain);
  yield takeLatest(types.PETTY_CASHIER_DASHBOARD_GET_CLASSIFICATION_REQUEST, workerPettyCashierClassification);
  yield takeLatest(types.PETTY_CASHIER_DASHBOARD_GET_PAYMENT_REQUEST, workerPettyCashierPayment);
}

function* workerPettyCashier2Number() {
  try {
    const response = yield call(fetchPettyCashier2Number);
    let data = response.data;
    yield put(DashboardAction.pettyCashierGetTwoNumbersSuccess(data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(DashboardAction.pettyCashierGetTwoNumbersFailure(message));
  }
}

function fetchPettyCashier2Number() {
  return DashboardApi.pettyCashierGetTwoNumbers();
}


function* workerPettyCashierCashRemain() {
  try {
    const response = yield call(fetchPettyCashierCashRemain);
    let data = response.data;
    yield put(DashboardAction.pettyCashierGetCashRemainSuccess(data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(DashboardAction.pettyCashierGetCashRemainFailure(message));
  }
}

function fetchPettyCashierCashRemain() {
  return DashboardApi.pettyCashierGetCashRemain();
}

function* workerPettyCashierClassification() {
  try {
    const response = yield call(fetchPettyCashierClassification);
    let data = response.data;
    yield put(DashboardAction.pettyCashierGetClassificationSuccess(data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(DashboardAction.pettyCashierGetClassificationFailure(message));
  }
}

function fetchPettyCashierClassification() {
  return DashboardApi.pettyCashierGetClassification();
}


function* workerPettyCashierPayment() {
  try {
    const response = yield call(fetchPettyCashierPayment);
    let data = response.data;
    yield put(DashboardAction.pettyCashierGetPaymentSuccess(data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(DashboardAction.pettyCashierGetPaymentFailure(message));
  }
}

function fetchPettyCashierPayment() {
  return DashboardApi.pettyCashierGetPayment();
}